import HttpClient from "./HttpClient";

export default class Supplier {
    constructor(supplier){
        this.id = supplier.id;
        this.title = supplier.title;
        this.short_title = supplier.short_title;
        this.company_id = supplier.company_id;
        this.created_at = supplier.created_at;
        this.updated_at = supplier.updated_at;
        this.order_number = supplier.order_number;
    }

    static async loadSuppliers(currentPage)
    {
        const client = new HttpClient();
        const response = await client.instance.get("suppliers", {
            page: currentPage
        });
        const suppliers = [];
        response.data.forEach(supplier => {
            suppliers.push(new Supplier(supplier));
        });
        return suppliers;
    }

    static async loadShowing(){
        const client = new HttpClient();
        const response = await client.instance.get("suppliers/showing");
        const suppliers = [];
        response.data.forEach(supplier => {
            suppliers.push(new Supplier(supplier));
        })
        return suppliers;
    }

    static async create(data){
        const client = new HttpClient();
        const response = await client.instance.post("suppliers", data);
        return response.data;
    }

    static async createShowingSuppliers(data){
        const client = new HttpClient();
        const response = await client.instance.post('showing-suppliers', data);
        return response.data;
    }

    async remove(){
        const client = new HttpClient();
        const response = await client.instance.delete(`suppliers/${this.id}`);
        return response.data;
    }
}